import React, { useEffect, useState } from "react";
import {
  UncontrolledDropdown,
  Button,
  Row,
  Col,
  Spinner,
  Alert,
} from "reactstrap";
import { Icon } from "../Component";
import { Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";
import FormInput from "../../pages/form-components/InputComponent";
import { ReactTyped } from "react-typed";
import { FormProvider, useForm } from "react-hook-form";
import miscService from "../../api/misc/misc";
import { useDispatch, useSelector } from "react-redux";
import { setUploadHighlight } from "../../store/slices/misc/highlightSlice";
import { RootState } from "../../store/store";
import supplierApis from "../../api/master/supplier";
import exportFromJSON from "export-from-json";
import * as XLSX from "xlsx";
import misc from "../../api/misc/dropDowns";
import { uploadApis } from "../../api/Uploads";
import { exportToXLSX } from "../../utils/Utils";
import boqApis from "../../api/boq/boq";
const blobUrl: String = process.env.REACT_APP_BLOB_URL || "";
const blobContainer: String = process.env.REACT_APP_BLOB_CONTAINER || "";
interface SelectOptions {
  label: string;
  value: any;
}

// const exportToXLSX = (data: any, fileName: string) => {
//   const worksheet = XLSX.utils.json_to_sheet(data);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
//   XLSX.writeFile(workbook, `${fileName}.xlsx`);
// };

const Configuration: any = {
  "suppliers-list": {
    title: "Bulk Suppliers Creation",
    requestType: "supplierCreate",
  },
  "material-list": {
    title: "Bulk Material Creation",
    requestType: "materialCreate",
  },
  "purchase-request-upload": {
    title: "Purchase Requests Creation",
    requestType: "purchase-request-upload",
  },
  "purchase-order-upload": {
    title: "Purchase Orders Creation",
    requestType: "purchase-order-upload",
  },
  "invoice-grn-upload": {
    title: "Invoice & GRN Creation",
    requestType: "invoice-grn-upload",
  },
  "payments-upload": {
    title: "Payments Creation",
    requestType: "payments-upload",
  },
  "consumption-target-list": {
    title: "BOQ Bulk Upload",
    requestType: "consumption-target-upload",
  },
  stockCreate: {
    title: "Bulk Stock Creation",
    requestType: "stockCreate",
  },
};

const BulkUpload = ({
  showAsButton = true,
  moduleKey,
}: {
  moduleKey?: any;
  showAsButton?: boolean;
}) => {
  const [categories, setCategories] = useState<any>([]);
  const [sites, setSites] = useState<any>([]);
  const [materials, setMaterials] = useState<any>([]);
  const [siteReferences, setSiteReferences] = useState<any>(null);
  const [selectedSiteId, setSelectedSiteId] = useState<string | null>(null);
  const { data: currentUser } = useSelector(
    (state: RootState) => state.currentUser
  );

  console.log(siteReferences, "siteReferences");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [blockEdit, setBlockEdit] = useState(false);
  const [response, setResponse] = useState({
    status: "",
    message: "",
  });
  const [response2, setResponse2] = useState({
    status: "",
    message: "",
  });
  const [uomOptions, setUomOptions] = useState<SelectOptions[]>([]);

  const methods = useForm({
    mode: "onChange",
  });
  const {
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = methods;
  const files = watch("attachment");
  const files2 = watch("attachment2");

  useEffect(() => {
    setResponse({ status: "", message: "" });
  }, [files]);

  useEffect(() => {
    setResponse2({ status: "", message: "" });
  }, [files2]);

  const [showModal, setShowModal] = useState(false);
  const [referenceDataMessage, setReferenceDataMessage] = useState<{
    show: boolean;
    text: string;
  } | null>(null);

  const fetchCategoryList = async () => {
    try {
      const { data, status } = await supplierApis.fetchSupplierCategory();
      if (status) {
        const categoryOption = data.map((item: any) => ({
          categoryName: item.category,
          categoryId: item.id.toString(),
        }));
        setCategories(categoryOption);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchSiteList = async () => {
    try {
      const { data, status } = await miscService.fetchSitesFiltered();
      if (status) {
        const siteOption = data.map((item: any) => ({
          siteName: item?.name,
          siteId: item?.siteID?.toString(),
        }));
        setSites(siteOption);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchMaterialList = async () => {
    try {
      const { data, status } = await miscService.fetchProductFiltered();
      if (status) {
        const materialOption = data.map((item: any) => {
          // When primary and secondary UOMs are the same (or no secondary),
          // leave the secondary columns blank — there's no real second UOM.
          const hasDistinctSecondary =
            item?.secondaryUomId != null &&
            item?.primaryUomId !== item?.secondaryUomId;
          return {
            "Category Name": item?.categoryName,
            materialName: item?.productName,
            materialId: item?.materialID?.toString(),
            "Primary UOM Name": item?.primaryUomName,
            "Primary UOM ID": item?.primaryUomId?.toString(),
            "Secondary UOM Name": hasDistinctSecondary
              ? item?.secondaryUomName
              : "",
            "Secondary UOM ID": hasDistinctSecondary
              ? item?.secondaryUomId?.toString()
              : "",
          };
        });
        setMaterials(materialOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const fetchUOMOPtions = async () => {
  //   try {
  //     const { data, status, message } = await misc.fetchAllUomByType("primary");
  //     if (status) {
  //       setUomOptions(
  //         data.map((item: any) => {
  //           return {
  //             label: item.uom_name,
  //             value: item.id,
  //           };
  //         })
  //       );
  //     } else {
  //       console.log(message);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const fetchSiteReferences = async (
    siteIds: string | string[],
    dependencies?: string | string[]
  ): Promise<any[]> => {
    try {
      const siteParam = Array.isArray(siteIds) ? siteIds.join(",") : siteIds;
      const response = await uploadApis.fetchProcurementReferences(
        siteParam,
        dependencies
      );
      // API may return array of sites or single object (e.g. for BUDGETS); normalize to array
      const data =
        Array.isArray(response) && response.length > 0
          ? response
          : response && typeof response === "object" && !Array.isArray(response)
            ? [response]
            : [];
      setSiteReferences(data);
      return data;
    } catch (error) {
      setSiteReferences([]);
      return [];
    }
  };

  // Function to generate users reference data (refs from fetchSiteReferences return used to avoid state race)
  const generateUsersReference = (templateType?: string, refs?: any[]) => {
    const refsToUse = refs ?? siteReferences;
    if (!refsToUse || !Array.isArray(refsToUse)) return [];
    const allUsers: any[] = [];
    refsToUse.forEach((site: any) => {
      if (
        site?.usersWithSitePreference &&
        Array.isArray(site.usersWithSitePreference)
      ) {
        site.usersWithSitePreference.forEach((user: any) => {
          const userId =
            templateType === "purchase-order-upload" ||
              templateType === "invoice-grn-upload"
              ? user.appUserId
              : user.id;
          // console.log(userId, "id");

          allUsers.push({
            id: userId,
            name: user.name,
            siteName: site.name,
          });
        });
      }
    });
    return allUsers.filter(
      (user, index, self) => index === self.findIndex((u) => u.id === user.id)
    );
  };

  const generateContractorsReference = (refs?: any[], siteIdFilter?: string | null) => {
    const refsToUse = refs ?? siteReferences;
    if (!refsToUse || !Array.isArray(refsToUse)) return [];

    const activeFilter = siteIdFilter !== undefined ? siteIdFilter : selectedSiteId;

    const allContractors: any[] = [];
    refsToUse.forEach((site: any) => {
      // Filter by activeFilter if set
      if (
        activeFilter &&
        site.siteId?.toString() !== activeFilter &&
        site.id?.toString() !== activeFilter
      ) {
        return;
      }
      if (
        site?.contractorsWithSitePreference &&
        Array.isArray(site.contractorsWithSitePreference)
      ) {
        site.contractorsWithSitePreference.forEach((contractor: any) => {
          allContractors.push({
            id: contractor.id,
            companyName: contractor.companyName,
            siteName: site.name,
          });
        });
      }
    });

    // If no contractors found for the site, return a header-only template row so the xlsx still has column headers
    if (allContractors.length === 0) {
      return [{ id: "", companyName: "", siteName: "" }];
    }
    return allContractors;
  };

  // Function to generate site structure reference data from ALL sites
  const generateSiteStructureReference = (refs?: any[], siteIdFilter?: string | null) => {
    const refsToUse = refs ?? siteReferences;
    if (!refsToUse || !Array.isArray(refsToUse)) return [];

    const activeFilter = siteIdFilter !== undefined ? siteIdFilter : selectedSiteId;

    const structureData: any[] = [];

    refsToUse.forEach((site: any) => {
      // Filter by activeFilter if set
      if (
        activeFilter &&
        site.siteId?.toString() !== activeFilter &&
        site.id?.toString() !== activeFilter
      ) {
        return;
      }
      if (site?.siteStructures && Array.isArray(site.siteStructures)) {
        site.siteStructures.forEach((structure: any) => {
          if (structure?.units && Array.isArray(structure.units)) {
            structure.units.forEach((unit: any) => {
              if (unit?.subUnits && Array.isArray(unit.subUnits)) {
                unit.subUnits.forEach((subUnit: any) => {
                  structureData.push({
                    siteName: site.name,
                    projectName: structure.projectName || "",
                    unitId: unit.id || "",
                    unitName: unit.unitName || "",
                    subUnitId: subUnit.id || "",
                    subUnitName: subUnit.subUnitName || "",
                    floorNo: subUnit.floorNo || "",
                    floorType: subUnit.floorType || "",
                  });
                });
              }
            });
          }
        });
      }
    });

    // If no structures found for the site, return a header-only template row so the xlsx still has column headers
    if (structureData.length === 0) {
      return [{
        siteName: "",
        projectName: "",
        unitId: "",
        unitName: "",
        subUnitId: "",
        subUnitName: "",
        floorNo: "",
        floorType: "",
      }];
    }
    return structureData;
  };

  // Function to generate delivery addresses reference data from ALL sites
  const generateDeliveryAddressesReference = (refs?: any[]) => {
    const refsToUse = refs ?? siteReferences;
    if (!refsToUse || !Array.isArray(refsToUse)) return [];

    const allAddresses: any[] = [];
    refsToUse.forEach((site: any) => {
      if (site?.deliveryAddresses && Array.isArray(site.deliveryAddresses)) {
        site.deliveryAddresses.forEach((address: any) => {
          allAddresses.push({
            id: address.id,
            deliveryLocationName: address.deliveryLocationName,
            addressLine1: address.addressLine1,
            addressLine2: address.addressLine2,
            city: address.city,
            pincode: address.pincode,
            districtName: address.districtName,
            stateName: address.stateName,
            countryName: address.countryName,
            siteName: site.name,
          });
        });
      }
    });

    return allAddresses;
  };

  // Function to generate locations reference data from ALL sites
  const generateLocationsReference = (refs?: any[], siteIdFilter?: string | null) => {
    try {
      const refsToUse = refs ?? siteReferences;
      if (!refsToUse || !Array.isArray(refsToUse)) {
        return [];
      }

      const activeFilter = siteIdFilter !== undefined ? siteIdFilter : selectedSiteId;

      const allLocations: any[] = [];

      refsToUse.forEach((site: any) => {
        // Filter by activeFilter if set
        if (
          activeFilter &&
          site.siteId?.toString() !== activeFilter &&
          site.id?.toString() !== activeFilter
        ) {
          return;
        }
        if (site?.siteStructures && Array.isArray(site.siteStructures)) {
          site.siteStructures.forEach((structure: any) => {
            if (structure && Array.isArray(structure.locations)) {
              structure.locations.forEach((location: any) => {
                if (location && location.id && location.locationName) {
                  allLocations.push({
                    id: location.id,
                    locationName: location.locationName,
                    siteName: site.name,
                  });
                }
              });
            }
          });
        }
      });

      // If no locations found for the site, return a header-only template row so the xlsx still has column headers
      if (allLocations.length === 0) {
        return [{ id: "", locationName: "", siteName: "" }];
      }
      return allLocations;
    } catch (error) {
      // console.error("Error generating locations reference:", error);
      return [];
    }
  };

  const generateBudgetReference = (refs?: any[]) => {
    const raw = refs ?? siteReferences;
    if (!raw) return [];
    const refsToUse = Array.isArray(raw) ? raw : [raw];
    const allBudgetInfo: any[] = [];
    refsToUse.forEach((site: any) => {
      const siteName = site?.name ?? site?.siteName ?? "";
      // API shape: budgetDetails is array of { id, name, lines: [{ id, lineCode, lineName }] }
      const budgetDetails =
        site?.budgetDetails ?? site?.budget_details ?? [];
      const detailsArray = Array.isArray(budgetDetails) ? budgetDetails : [];
      detailsArray.forEach((budget: any) => {
        const lines =
          budget?.lines ?? budget?.budgetLines ?? [];
        const linesArray = Array.isArray(lines) ? lines : [];
        linesArray.forEach((line: any) => {
          const name = line?.lineName ?? line?.line_name ?? line?.name ?? "";
          if (line?.id != null || name) {
            allBudgetInfo.push({
              id: line?.id ?? line?.budgetId ?? "",
              name,
              siteName: siteName,
            });
          }
        });
      });
    });
    return allBudgetInfo.filter(
      (user, index, self) => index === self.findIndex((u) => u.id === user.id)
    );
  };

  // Guard: download reference data. null/undefined => refs still loading; empty array => loaded but no rows for this site (still download so the user gets a header-only template).
  const exportReferenceData = (
    data: any[] | null | undefined,
    fileName: string,
    label?: string
  ) => {
    if (data == null || !Array.isArray(data)) {
      setReferenceDataMessage({
        show: true,
        text: "Reference data is not available yet. Please wait for the page to finish loading and try again.",
      });
      return;
    }
    setReferenceDataMessage(null);
    exportToXLSX(data, fileName);
  };

  useEffect(() => {
    // Only fetch data when modal is open
    if (!showModal) return;

    switch (moduleKey) {
      case "suppliers-list":
        fetchCategoryList();
        break;
      case "material-list":
        fetchCategoryList();
        fetchSiteList();
        fetchMaterialList();
        break;
      case "purchase-request-upload":
        fetchSiteList();
        // fetchUOMOPtions();
        fetchMaterialList();
        break;
      case "purchase-order-upload":
        fetchSiteList();
        // fetchUOMOPtions();
        fetchMaterialList();
        break;
      case "invoice-grn-upload":
        fetchSiteList();
        // fetchUOMOPtions();
        fetchMaterialList();
        break;
      case "payments-upload":
        break;
      case "consumption-target-list":
        // Use current user's site accessibility instead of fetching all sites
        if (currentUser?.siteAccessibility) {
          const siteOption = currentUser.siteAccessibility.map((item: any) => ({
            siteName: item.siteName,
            siteId: item.siteID?.toString(),
          }));
          setSites(siteOption);
        }
        // fetchUOMOPtions();
        fetchMaterialList();
        break;
      default:
        alert("(Bulk upload useEffect ) Invalid module key " + moduleKey);
    }
  }, [moduleKey, showModal, currentUser]);

  useEffect(() => {
    if (
      (moduleKey === "purchase-request-upload" ||
        moduleKey === "purchase-order-upload" ||
        moduleKey === "invoice-grn-upload") &&
      sites.length > 0
    ) {
      const siteIds = sites.map((site: any) => site.siteId);
      fetchSiteReferences(siteIds);
    }
    // For consumption-target-list, don't auto-fetch - let user click on site-specific links
  }, [sites, moduleKey]);

  // Clear "reference data not available" message when reference data has loaded
  useEffect(() => {
    if (referenceDataMessage?.show && (sites?.length > 0 || materials?.length > 0 || (siteReferences && Array.isArray(siteReferences) && siteReferences.length > 0))) {
      setReferenceDataMessage(null);
    }
  }, [sites, materials, siteReferences]);

  const handleUpload = async (value: any, moduleKey: string) => {
    try {
      switch (moduleKey) {
        case "suppliers-list":
          if (!value?.attachment || !value?.attachment[0]) {
            setResponse({
              status: "error",
              message: "Please select a file",
            });
            setBlockEdit(false);
            setLoading(false);
            return;
          }
          uploadFile(
            value?.attachment,
            moduleKey,
            setResponse,
            "Supplier File Uploaded Successfully"
          );
          break;
        case "material-list":
          if (value?.attachment?.[0] || value?.attachment2?.[0]) {
            if (value?.attachment?.[0]) {
              await uploadFile(
                value?.attachment,
                moduleKey,
                setResponse,
                "Material File Uploaded Successfully"
              );
            }
            if (value?.attachment2?.[0]) {
              await uploadFile(
                value?.attachment2,
                "stockCreate",
                setResponse2,
                "Stocks File Uploaded Successfully"
              );
            }
          } else {
            setResponse({
              status: "error",
              message: "Please Upload either Material File or Stocks File",
            });
            setBlockEdit(false);
            setLoading(false);
          }
          break;
        case "purchase-request-upload":
          if (!value?.attachment || !value?.attachment[0]) {
            setResponse({
              status: "error",
              message: "Please select a file",
            });
            setBlockEdit(false);
            setLoading(false);
            return;
          }
          uploadFile(
            value?.attachment,
            moduleKey,
            setResponse,
            "Purchase Request Uploaded Successfully"
          );
          break;
        case "purchase-order-upload":
          if (!value?.attachment || !value?.attachment[0]) {
            setResponse({
              status: "error",
              message: "Please select a file",
            });
            setBlockEdit(false);
            setLoading(false);
            return;
          }
          uploadFile(
            value?.attachment,
            moduleKey,
            setResponse,
            "Purchase Order Uploaded Successfully"
          );
          break;
        case "invoice-grn-upload":
          if (!value?.attachment || !value?.attachment[0]) {
            setResponse({
              status: "error",
              message: "Please select a file",
            });
            setBlockEdit(false);
            setLoading(false);
            return;
          }
          uploadFile(
            value?.attachment,
            moduleKey,
            setResponse,
            "Invoice File Uploaded Successfully"
          );
          break;
        case "payments-upload":
          if (!value?.attachment || !value?.attachment[0]) {
            setResponse({
              status: "error",
              message: "Please select a file",
            });
            setBlockEdit(false);
            setLoading(false);
            return;
          }
          uploadFile(
            value?.attachment,
            moduleKey,
            setResponse,
            "Payment File Uploaded Successfully"
          );
          break;
        case "consumption-target-list":
          if (!value?.attachment || !value?.attachment[0]) {
            setResponse({
              status: "error",
              message: "Please select a file",
            });
            setBlockEdit(false);
            setLoading(false);
            return;
          }
          uploadFile(
            value?.attachment,
            moduleKey,
            setResponse,
            "BOQ File Uploaded Successfully"
          );
          break;
        default:
          alert("(Bulk upload handleUpload ) Invalid module key " + moduleKey);
      }
    } catch (error) { }
  };

  const uploadFile = async (
    attachment: any,
    moduleKey: string,
    setResponse: any,
    successResponse: any
  ) => {
    try {
      const _file = attachment?.[0];
      if (moduleKey === "purchase-request-upload") {
        // const body = {
        //   module: "procurement",
        //   requestType: Configuration[moduleKey].requestType,
        //   action: "Preview",
        // };

        const res = await uploadApis.uploadPurchaseRequestBulk(_file);
        const { status, message, error } = res || {};

        if (status) {
          dispatch(setUploadHighlight(true));
          setResponse({
            status: "success",
            message: successResponse,
          });
        } else {
          setResponse({
            status: "error",
            message: error || message || "Something went wrong",
          });
        }

        setBlockEdit(false);
        setLoading(false);
        return;
      }

      if (moduleKey === "purchase-order-upload") {
        const res = await uploadApis.uploadPurchaseOrderBulk(_file);
        const { status, message, error } = res || {};

        if (status) {
          dispatch(setUploadHighlight(true));
          setResponse({
            status: "success",
            message: successResponse,
          });
        } else {
          setResponse({
            status: "error",
            message: error || message || "Something went wrong",
          });
        }

        setBlockEdit(false);
        setLoading(false);
        return;
      }

      if (moduleKey === "invoice-grn-upload") {
        const res = await uploadApis.uploadInvoiceBulk(_file);
        const { status, message, error } = res || {};

        if (status) {
          dispatch(setUploadHighlight(true));
          setResponse({
            status: "success",
            message: successResponse,
          });
        } else {
          setResponse({
            status: "error",
            message: error || message || "Something went wrong",
          });
        }

        setBlockEdit(false);
        setLoading(false);
        return;
      }

      if (moduleKey === "payments-upload") {
        const res = await uploadApis.uploadPaymentBulk(_file);
        const { status, message, error } = res || {};

        if (status) {
          dispatch(setUploadHighlight(true));
          setResponse({
            status: "success",
            message: successResponse,
          });
        } else {
          setResponse({
            status: "error",
            message: error || message || "Something went wrong",
          });
        }

        setBlockEdit(false);
        setLoading(false);
        return;
      }

      if (moduleKey === "consumption-target-list") {
        const res = await boqApis.bulkUpload(_file);
        const { status, message, error } = res || {};

        if (status) {
          dispatch(setUploadHighlight(true));
          setResponse({
            status: "success",
            message: successResponse,
          });
        } else {
          setResponse({
            status: "error",
            message: error || message || "Something went wrong",
          });
        }

        setBlockEdit(false);
        setLoading(false);
        return;
      }

      const formData: any = new FormData();
      formData.append(
        "filesData",
        JSON.stringify({
          module: "MDM",
          requestType: Configuration[moduleKey].requestType,
          action: "Preview",
          reportId: "",
          processedExcelData: {},
        })
      );
      formData.append("files", _file);
      const res = await miscService.bulkUpload(formData);
      const { status, error, message } = res || {};

      if (status) {
        dispatch(setUploadHighlight(true));
        setResponse({
          status: "success",
          message: successResponse,
        });
        setBlockEdit(false);
        setLoading(false);
        return;
      } else {
        setResponse({
          status: "error",
          message: error || message,
        });
      }

      setBlockEdit(false);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setResponse({
        status: "error",
        message: "Unexpected error occurred while uploading",
      });
      setBlockEdit(false);
      setLoading(false);
    }
  };

  const ModalContent = ({ moduleKey }: any) => {
    switch (moduleKey) {
      case "suppliers-list":
        return (
          <>
            <p>
              You're about to create multiple supplier records at once. To
              ensure a smooth import, please{" "}
              <a
                href={`${blobUrl}${blobContainer}/supplier_bulk_upload.xlsx`}
                target="_blank"
                style={{
                  textDecoration: "underline",
                }}
              >
                Download Template
              </a>{" "}
              and fill in the required supplier data accurately and completely,
              then upload the file below. you can check{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  const exportType = exportFromJSON.types.csv;
                  exportFromJSON({
                    data: categories,
                    fileName: "Categories",
                    exportType,
                  });
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Categories
              </a>{" "}
              for reference
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong>
              All fields in the template are mandatory. Each supplier must have
              unique information to avoid errors during the import process.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  // required
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      case "material-list":
        return (
          <>
            <p>
              You're about to create multiple material records at once. To
              ensure a smooth import, please{" "}
              <a
                href={`${blobUrl}${blobContainer}/material_upload_template.xlsx`}
                target="_blank"
                style={{
                  textDecoration: "underline",
                }}
              >
                Materials Download Template
              </a>{" "}
              {" / "}
              <a
                href={`${blobUrl}${blobContainer}/stock_upload_template.xlsx`}
                target="_blank"
                style={{
                  textDecoration: "underline",
                }}
              >
                Stock Materials Download Template
              </a>{" "}
              and fill in the required material data accurately and completely,
              then upload the file below. you can check{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  const exportType = exportFromJSON.types.csv;
                  exportFromJSON({
                    data: sites,
                    fileName: "Sites",
                    exportType,
                  });
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Sites
              </a>
              ,{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  const exportType = exportFromJSON.types.csv;
                  exportFromJSON({
                    data: categories,
                    fileName: "Categories",
                    exportType,
                  });
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Categories
              </a>{" "}
              and{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  const exportType = exportFromJSON.types.csv;
                  exportFromJSON({
                    data: materials,
                    fileName: "Materials",
                    exportType,
                  });
                }}
                target="_self"
                style={{ textDecoration: "underline" }}
              >
                Materials
              </a>{" "}
              for reference
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong>
              All fields in the template are mandatory. Each material must have
              unique information to avoid errors during the import process.
            </p>
            <div className="d-flex">
              <Col md={4}>
                {files && files[0]?.name && (
                  <div className="form-group m-0">
                    <div className="form-label-wrapper">
                      <label className="form-label" htmlFor={"attachment"}>
                        Materials File Upload Area
                      </label>
                    </div>
                    <div
                      className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                      style={{ borderRadius: "3px" }}
                    >
                      <span>{files && files[0]?.name}</span>
                      {!blockEdit && (
                        <span
                          onClick={() => {
                            setValue("attachment", null);
                          }}
                          style={{
                            cursor: "pointer",
                            marginLeft: "10px",
                            display: "block",
                            fontSize: 14,
                          }}
                        >
                          <Icon name="cross"></Icon> &nbsp;
                        </span>
                      )}
                    </div>
                  </div>
                )}
                <div
                  style={{
                    display: `${files && files[0]?.name ? "none" : "block"}`,
                  }}
                >
                  <FormInput
                    type="file"
                    name="attachment"
                    // required
                    label="Materials File Upload Area"
                    placeholder="File Upload Area"
                    accept=".xlsx" // ,.xls,.csv
                  />
                </div>
              </Col>
              <Col md={4} className="ms-3">
                {files2 && files2[0]?.name && (
                  <div className="form-group m-0">
                    <div className="form-label-wrapper">
                      <label className="form-label" htmlFor={"attachment"}>
                        Stock Materials File Upload Area
                      </label>
                    </div>
                    <div
                      className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                      style={{ borderRadius: "3px" }}
                    >
                      <span>{files2 && files2[0]?.name}</span>
                      {!blockEdit && (
                        <span
                          onClick={() => {
                            setValue("attachment2", null);
                          }}
                          style={{
                            cursor: "pointer",
                            marginLeft: "10px",
                            display: "block",
                            fontSize: 14,
                          }}
                        >
                          <Icon name="cross"></Icon> &nbsp;
                        </span>
                      )}
                    </div>
                  </div>
                )}
                <div
                  style={{
                    display: `${files2 && files2[0]?.name ? "none" : "block"}`,
                  }}
                >
                  <FormInput
                    type="file"
                    // required
                    name="attachment2"
                    label="Stock Materials File Upload Area"
                    placeholder="File Upload Area"
                    accept=".xlsx" // ,.xls,.csv
                  />
                </div>
              </Col>
            </div>
          </>
        );
      case "purchase-request-upload":
        return (
          <>
            <div style={{ marginBottom: "12px" }}>
              <p>
                You're about to create multiple <strong>Purchase Request</strong>{" "}
                records at once. To ensure a smooth import, please{" "}
                <a
                  href={`${blobUrl}${blobContainer}/purchase-request-bulk-upload-template.xlsx`}
                  target="_blank"
                  style={{ textDecoration: "underline" }}
                >
                  Download Template
                </a>{" "}
                and fill in the required purchase request data accurately and
                completely, then upload the file below. You can check{" "}
              </p>
            </div>

            {/* Reference Data Section */}
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "10px",
                borderRadius: "6px",
                marginBottom: "12px",
                border: "1px solid #e9ecef",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#495057",
                  marginBottom: "6px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Icon
                  name="info"
                  style={{
                    marginRight: "6px",
                    fontSize: "14px",
                    display: "inline-flex",
                    alignItems: "center",
                    lineHeight: "1",
                  }}
                />
                <span
                  style={{
                    lineHeight: "1",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  Reference Data
                </span>
              </div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  marginBottom: "10px",
                }}
              >
                Download reference data for accurate data entry:{" "}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    exportReferenceData(sites, "Sites");
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#2263b3",
                    fontWeight: "600",
                    marginRight: "8px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e7f1ff";
                    e.currentTarget.style.color = "#1a4d8c";
                    e.currentTarget.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#2263b3";
                    e.currentTarget.style.textDecoration = "none";
                  }}
                >
                  <Icon name="file-text" style={{ marginRight: "4px" }} />
                  Sites
                </a>
                and{" "}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    exportReferenceData(materials, "Materials");
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#2263b3",
                    fontWeight: "600",
                    marginLeft: "4px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e7f1ff";
                    e.currentTarget.style.color = "#1a4d8c";
                    e.currentTarget.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#2263b3";
                    e.currentTarget.style.textDecoration = "none";
                  }}
                >
                  <Icon name="file-text" style={{ marginRight: "4px" }} />
                  Materials
                </a>
              </p>

              {/* Site-specific References */}
              {sites.length > 0 && (
                <div style={{ marginTop: "10px" }}>
                  <div
                    style={{
                      fontSize: "11px",
                      fontWeight: "600",
                      color: "#495057",
                      marginBottom: "6px",
                    }}
                  >
                    Site-Specific References:
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: "6px",
                      maxHeight: "150px",
                      overflowY: "auto",
                      padding: "4px",
                    }}
                  >
                    {sites.map((site: any) => (
                      <div
                        key={site.siteId}
                        style={{
                          backgroundColor: "#fff",
                          padding: "6px",
                          borderRadius: "4px",
                          border: "1px solid #dee2e6",
                          transition: "box-shadow 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.boxShadow =
                            "0 2px 4px rgba(0,0,0,0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "600",
                            color: "#212529",
                            marginBottom: "4px",
                            fontSize: "12px",
                          }}
                        >
                          {site.siteName}
                        </div>
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#6c757d",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "4px",
                          }}
                        >
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "SITE_PREFERRED_USERS",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateUsersReference(undefined, refs),
                                `${site.siteName}_Users`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Users
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "PREFERRED_CONTRACTORS",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateContractorsReference(refs, site.siteId?.toString() || site.siteId),
                                `${site.siteName}_Contractors`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Contractors
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "SITE_STRUCTURES",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateSiteStructureReference(refs, site.siteId?.toString() || site.siteId),
                                `${site.siteName}_Site_Structures`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Site Structures
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "LOCATIONS",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateLocationsReference(refs, site.siteId?.toString() || site.siteId),
                                `${site.siteName}_Locations`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Locations
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "DELIVERY_ADDRESSES",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateDeliveryAddressesReference(refs),
                                `${site.siteName}_Delivery_Addresses`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Delivery Addresses
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>


            <div className="text-right mt-3"></div>
            <p>
              <strong>Note:</strong> All fields in the template are mandatory.
              Each purchase request must have unique information to avoid errors
              during the import process.
            </p>

            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx"
                />
              </div>
            </Col>
          </>
        );
      case "purchase-order-upload":
        return (
          <>
            <div style={{ marginBottom: "12px" }}>
              <p>
                You're about to create multiple <strong>Purchase Order</strong>{" "}
                records at once. To ensure a smooth import, please{" "}
                <a
                  href={`${blobUrl}${blobContainer}/PurchaseOrderBulkupload.xlsx`}
                  target="_blank"
                  style={{ textDecoration: "underline" }}
                >
                  Download Template
                </a>{" "}
                and fill in the required purchase order data accurately and
                completely, then upload the file below. You can check
                for reference.
              </p>
            </div>

            {/* Reference Data Section */}
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "10px",
                borderRadius: "6px",
                marginBottom: "12px",
                border: "1px solid #e9ecef",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#495057",
                  marginBottom: "6px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Icon
                  name="info"
                  style={{
                    marginRight: "6px",
                    fontSize: "14px",
                    display: "inline-flex",
                    alignItems: "center",
                    lineHeight: "1",
                  }}
                />
                <span
                  style={{
                    lineHeight: "1",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  Reference Data
                </span>
              </div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  marginBottom: "10px",
                }}
              >
                Download reference data for accurate data entry:{" "}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    exportReferenceData(sites, "Sites");
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#2263b3",
                    fontWeight: "600",
                    marginRight: "8px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e7f1ff";
                    e.currentTarget.style.color = "#1a4d8c";
                    e.currentTarget.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#2263b3";
                    e.currentTarget.style.textDecoration = "none";
                  }}
                >
                  <Icon name="file-text" style={{ marginRight: "4px" }} />
                  Sites
                </a>
                and{" "}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    exportReferenceData(materials, "Materials");
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#2263b3",
                    fontWeight: "600",
                    marginLeft: "4px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e7f1ff";
                    e.currentTarget.style.color = "#1a4d8c";
                    e.currentTarget.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#2263b3";
                    e.currentTarget.style.textDecoration = "none";
                  }}
                >
                  <Icon name="file-text" style={{ marginRight: "4px" }} />
                  Materials
                </a>
              </p>

              {/* Site-specific References */}
              {sites.length > 0 && (
                <div style={{ marginTop: "10px" }}>
                  <div
                    style={{
                      fontSize: "11px",
                      fontWeight: "600",
                      color: "#495057",
                      marginBottom: "6px",
                    }}
                  >
                    Site-Specific References:
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: "6px",
                      maxHeight: "150px",
                      overflowY: "auto",
                      padding: "4px",
                    }}
                  >
                    {sites.map((site: any) => (
                      <div
                        key={site.siteId}
                        style={{
                          backgroundColor: "#fff",
                          padding: "6px",
                          borderRadius: "4px",
                          border: "1px solid #dee2e6",
                          transition: "box-shadow 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.boxShadow =
                            "0 2px 4px rgba(0,0,0,0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "600",
                            color: "#212529",
                            marginBottom: "4px",
                            fontSize: "12px",
                          }}
                        >
                          {site.siteName}
                        </div>
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#6c757d",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "4px",
                          }}
                        >
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "SITE_PREFERRED_USERS",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateUsersReference(undefined, refs),
                                `${site.siteName}_Users`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Users
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "PREFERRED_CONTRACTORS",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateContractorsReference(refs, site.siteId?.toString() || site.siteId),
                                `${site.siteName}_Contractors`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Contractors
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "SITE_STRUCTURES",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateSiteStructureReference(refs, site.siteId?.toString() || site.siteId),
                                `${site.siteName}_Site_Structures`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Site Structures
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "BUDGETS",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateBudgetReference(refs),
                                `${site.siteName}_Budget`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Budget
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "LOCATIONS",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateLocationsReference(refs, site.siteId?.toString() || site.siteId),
                                `${site.siteName}_Locations`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Locations
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "DELIVERY_ADDRESSES",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateDeliveryAddressesReference(refs),
                                `${site.siteName}_Delivery_Addresses`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Delivery Addresses
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note:</strong> All fields in the template are mandatory.
              Each purchase order must have unique information to avoid errors
              during the import process.
            </p>

            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx"
                />
              </div>
            </Col>
          </>
        );
      case "invoice-grn-upload":
        return (
          <>
            <p>
              You're about to create multiple <strong>Invoice & GRN</strong>{" "}
              records at once. To ensure a smooth import, please{" "}
              <a
                href={`${blobUrl}${blobContainer}/invoice-bulk-upload-template`}
                target="_blank"
                style={{
                  textDecoration: "underline",
                }}
              >
                Download Template
              </a>{" "}
              and fill in the required Invoice & GRN data accurately and
              completely, then upload the file below. you can check{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  exportReferenceData(materials, "Materials");
                }}
                style={{ textDecoration: "underline" }}
              >
                Materials
              </a>
              ,{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  exportReferenceData(
                    uomOptions?.map((uom) => ({
                      uom_name: uom.label,
                      id: uom.value,
                    })) ?? [],
                    "UOMs"
                  );
                }}
                style={{ textDecoration: "underline" }}
              >
                UOMs
              </a>
              ,{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  exportReferenceData(
                    generateUsersReference(moduleKey),
                    "Users"
                  );
                }}
                style={{ textDecoration: "underline" }}
              >
                Users
              </a>
              , and{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  exportReferenceData(
                    generateDeliveryAddressesReference(),
                    "Delivery_Addresses"
                  );
                }}
                style={{ textDecoration: "underline" }}
              >
                Delivery Addresses
              </a>{" "}
              for reference
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong>
              All fields in the template are mandatory. Each Invoice & GRN must
              have unique information to avoid errors during the import process.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  // required
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      case "payments-upload":
        return (
          <>
            <p>
              You're about to create multiple <strong>Payments</strong> records
              at once. To ensure a smooth import, please{" "}
              <a
                href={`${blobUrl}${blobContainer}/paymentsbulkuploads.xlsx`}
                target="_blank"
                style={{
                  textDecoration: "underline",
                }}
              >
                Download Template
              </a>{" "}
              and fill in the required Payments data accurately and completely,
              then upload the file below.
            </p>

            <div className="text-right mt-3"></div>
            <p>
              <strong>Note : </strong>
              All fields in the template are mandatory. Each Payments must have
              unique information to avoid errors during the import process.
            </p>
            <Col md={4}>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div className="form-label-wrapper">
                    <label className="form-label" htmlFor={"attachment"}>
                      File Upload Area
                    </label>
                  </div>
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-1"
                    style={{ borderRadius: "3px" }}
                  >
                    <span>{files && files[0]?.name}</span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          marginLeft: "10px",
                          display: "block",
                          fontSize: 14,
                        }}
                      >
                        <Icon name="cross"></Icon> &nbsp;
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  // required
                  name="attachment"
                  label="File Upload Area"
                  placeholder="File Upload Area"
                  accept=".xlsx" // ,.xls,.csv
                />
              </div>
            </Col>
          </>
        );
      case "consumption-target-list":
        return (
          <>
            {/* Instructions Section */}
            <div style={{ marginBottom: "12px" }}>
              <p
                style={{
                  fontSize: "13px",
                  lineHeight: "1.4",
                  color: "#333",
                  marginBottom: "0",
                }}
              >
                You're about to create multiple <strong>BOQ</strong> records at
                once. To ensure a smooth import, please{" "}
                <a
                  href="https://procurexuatstg.blob.core.windows.net/procurexuatblob/site-consumption-target-bulk-upload-template.xlsx"
                  target="_blank"
                  style={{
                    textDecoration: "none",
                    color: "#2263b3",
                    fontWeight: "600",
                  }}
                >
                  <Icon name="download" style={{ marginRight: "4px" }} />
                  Download Template
                </a>{" "}
                and fill in the required BOQ data accurately and completely.
              </p>
            </div>

            {/* Reference Data Section */}
            <div
              style={{
                backgroundColor: "#f8f9fa",
                padding: "10px",
                borderRadius: "6px",
                marginBottom: "12px",
                border: "1px solid #e9ecef",
              }}
            >
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#495057",
                  marginBottom: "6px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Icon
                  name="info"
                  style={{
                    marginRight: "6px",
                    fontSize: "14px",
                    display: "inline-flex",
                    alignItems: "center",
                    lineHeight: "1",
                  }}
                />
                <span
                  style={{
                    lineHeight: "1",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  Reference Data
                </span>
              </div>
              <p
                style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  marginBottom: "10px",
                }}
              >
                Download reference data for accurate data entry:{" "}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    exportReferenceData(sites, "Sites");
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#2263b3",
                    fontWeight: "600",
                    marginRight: "8px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e7f1ff";
                    e.currentTarget.style.color = "#1a4d8c";
                    e.currentTarget.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#2263b3";
                    e.currentTarget.style.textDecoration = "none";
                  }}
                >
                  <Icon name="file-text" style={{ marginRight: "4px" }} />
                  Sites
                </a>
                and{" "}
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    exportReferenceData(materials, "Materials");
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#2263b3",
                    fontWeight: "600",
                    marginLeft: "4px",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "all 0.2s ease",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#e7f1ff";
                    e.currentTarget.style.color = "#1a4d8c";
                    e.currentTarget.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#2263b3";
                    e.currentTarget.style.textDecoration = "none";
                  }}
                >
                  <Icon name="file-text" style={{ marginRight: "4px" }} />
                  Materials
                </a>
              </p>

              {/* Site-specific References */}
              {sites.length > 0 && (
                <div style={{ marginTop: "10px" }}>
                  <div
                    style={{
                      fontSize: "11px",
                      fontWeight: "600",
                      color: "#495057",
                      marginBottom: "6px",
                    }}
                  >
                    Site-Specific References:
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: "6px",
                      maxHeight: "150px",
                      overflowY: "auto",
                      padding: "4px",
                    }}
                  >
                    {sites.map((site: any) => (
                      <div
                        key={site.siteId}
                        style={{
                          backgroundColor: "#fff",
                          padding: "6px",
                          borderRadius: "4px",
                          border: "1px solid #dee2e6",
                          transition: "box-shadow 0.2s",
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.boxShadow =
                            "0 2px 4px rgba(0,0,0,0.1)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.boxShadow = "none";
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "600",
                            color: "#212529",
                            marginBottom: "4px",
                            fontSize: "12px",
                          }}
                        >
                          {site.siteName}
                        </div>
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#6c757d",
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "4px",
                          }}
                        >
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "PREFERRED_CONTRACTORS",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateContractorsReference(refs, site.siteId?.toString() || site.siteId),
                                `${site.siteName}_Contractors`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Contractors
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "SITE_STRUCTURES",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateSiteStructureReference(refs, site.siteId?.toString() || site.siteId),
                                `${site.siteName}_Site_Structures`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Site Structures
                          </a>
                          <span style={{ color: "#dee2e6" }}>|</span>
                          <a
                            href="#"
                            onClick={async (e) => {
                              e.preventDefault();
                              const refs = await fetchSiteReferences(site.siteId, [
                                "LOCATIONS",
                              ]);
                              setSelectedSiteId(
                                site.siteId?.toString() || site.siteId
                              );
                              exportReferenceData(
                                generateLocationsReference(refs, site.siteId?.toString() || site.siteId),
                                `${site.siteName}_Locations`
                              );
                            }}
                            style={{
                              textDecoration: "none",
                              color: "#2263b3",
                              fontSize: "11px",
                              padding: "2px 6px",
                              borderRadius: "3px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = "#e7f1ff";
                              e.currentTarget.style.color = "#1a4d8c";
                              e.currentTarget.style.textDecoration =
                                "underline";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                              e.currentTarget.style.color = "#2263b3";
                              e.currentTarget.style.textDecoration = "none";
                            }}
                          >
                            Locations
                          </a>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* File Upload Section */}
            <div style={{ marginBottom: "12px" }}>
              <div
                style={{
                  fontSize: "12px",
                  fontWeight: "600",
                  color: "#495057",
                  marginBottom: "6px",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Icon
                  name="upload-cloud"
                  style={{ marginRight: "6px", fontSize: "14px" }}
                />
                Upload File
              </div>
              {files && files[0]?.name && (
                <div className="form-group m-0">
                  <div
                    className="form-control-wrap d-flex align-items-center justify-content-between border p-2"
                    style={{
                      borderRadius: "6px",
                      backgroundColor: "#f8f9fa",
                      borderColor: "#2263b3",
                    }}
                  >
                    <span
                      style={{
                        color: "#495057",
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Icon
                        name="file-text"
                        style={{ marginRight: "8px", color: "#2263b3" }}
                      />
                      {files && files[0]?.name}
                    </span>
                    {!blockEdit && (
                      <span
                        onClick={() => {
                          setValue("attachment", null);
                        }}
                        style={{
                          cursor: "pointer",
                          color: "#dc3545",
                          fontSize: "16px",
                          padding: "4px",
                        }}
                      >
                        <Icon name="cross"></Icon>
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div
                style={{
                  display: `${files && files[0]?.name ? "none" : "block"}`,
                }}
              >
                <FormInput
                  type="file"
                  name="attachment"
                  label=""
                  placeholder="Select Excel file (.xlsx)"
                  accept=".xlsx"
                />
              </div>
            </div>

            {/* Note Section */}
            <div
              style={{
                backgroundColor: "#fff3cd",
                border: "1px solid #ffc107",
                borderRadius: "6px",
                padding: "8px",
                marginTop: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "4px",
                }}
              >
                <Icon
                  name="info"
                  style={{
                    marginRight: "6px",
                    color: "#856404",
                    fontSize: "12px",
                    display: "inline-flex",
                    alignItems: "center",
                    lineHeight: "1",
                  }}
                />
                <strong
                  style={{
                    color: "#856404",
                    fontSize: "12px",
                    lineHeight: "1",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  Important:
                </strong>
              </div>
              <p
                style={{
                  margin: "0",
                  color: "#856404",
                  fontSize: "11px",
                  lineHeight: "1.3",
                }}
              >
                All fields in the template are mandatory. Each BOQ must have
                unique information to avoid errors during the import process.
              </p>
            </div>
          </>
        );
      default:
        <></>;
    }
    return <></>;
  };

  return (
    <>
      {showAsButton ? (
        <UncontrolledDropdown size={"md"}>
          {" "}
          <div
            onClick={() => {
              setShowModal(true);
            }}
            className="btn btn-white btn-outline-light"
          >
            <Icon name="upload-cloud"></Icon>
            <span>Import</span>
          </div>
        </UncontrolledDropdown>
      ) : (
        <Link
          to={`#`}
          onClick={() => {
            setShowModal(true);
          }}
        >
          <Icon name="upload-cloud"></Icon>
          <span>Upload</span>
        </Link>
      )}
      <Modal
        title={Configuration[moduleKey]?.title}
        open={showModal}
        footer={null}
        onCancel={() => {
          setShowModal(false);
          setBlockEdit(false);
          setReferenceDataMessage(null);
          methods.reset();
          setLoading(false);
          setSelectedSiteId(null);
          setResponse(() => ({
            status: "",
            message: "",
          }));
        }}
        width={"60%"}
      >
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(async (values) => {
              setResponse(() => ({
                status: "",
                message: "",
              }));
              setResponse2(() => ({
                status: "",
                message: "",
              }));
              setBlockEdit(true);
              setLoading(true);
              handleUpload(values, moduleKey);
            })}
          >
            {referenceDataMessage?.show && (
              <Alert
                color="info"
                className="d-flex align-items-center py-2 mt-2 mb-2"
                style={{ fontSize: "14px" }}
              >
                <Spinner size="sm" className="me-2" />
                {referenceDataMessage.text}
              </Alert>
            )}
            <ModalContent moduleKey={moduleKey} />
            <Alert
              isOpen={response?.status === "error"}
              color="danger"
              className="start-0 w-100 py-1 mt-2"
              style={{
                top: 0,
                textAlign: "left",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              <ReactTyped
                strings={[response?.message]}
                typeSpeed={30}
                showCursor={false}
              />
            </Alert>

            <Alert
              isOpen={response?.status === "success"}
              color="success"
              className="start-0 w-100 py-1 mt-2"
              style={{
                top: 0,
                textAlign: "left",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              <p>
                {response?.message}, Check status in the{" "}
                <span
                  className="inlineTableCellLink"
                  onClick={() => {
                    navigate("/bulk-upload-list", {
                      state: {
                        tab: "Bulk Upload",
                      },
                    });
                  }}
                >
                  Uploads History
                </span>
              </p>
            </Alert>
            <Alert
              isOpen={response2?.status === "error"}
              color="danger"
              className="start-0 w-100 py-1 mt-2"
              style={{
                top: 0,
                textAlign: "left",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              <ReactTyped
                strings={[response2?.message]}
                typeSpeed={30}
                showCursor={false}
              />
            </Alert>

            <Alert
              isOpen={response2?.status === "success"}
              color="success"
              className="start-0 w-100 py-1 mt-2"
              style={{
                top: 0,
                textAlign: "left",
                fontSize: "14px",
                cursor: "default",
              }}
            >
              <p>
                {response2?.message}, Check status in the{" "}
                <span
                  className="inlineTableCellLink"
                  onClick={() => {
                    navigate("/bulk-upload-list", {
                      state: {
                        tab: "Bulk Upload",
                      },
                    });
                  }}
                >
                  Uploads History
                </span>
              </p>
            </Alert>

            <Row className="mt-4">
              <Col>
                {response?.status == "success" ||
                  response2?.status == "success" ? (
                  <></>
                ) : (
                  <ul className="actions clearfix d-flex">
                    <li>
                      {loading ? (
                        <Button color="primary" type="button" size="md">
                          <Spinner size="sm" color="light" />
                        </Button>
                      ) : (
                        <Button
                          color="primary"
                          type="submit"
                        // disabled={
                        //   moduleKey == "material-list"
                        //     ? !files?.[0] || !files2?.[0]
                        //     : !files?.[0]
                        // }
                        >
                          Upload
                        </Button>
                      )}
                    </li>
                    {!loading && (
                      <li className="m-3 mt-0">
                        <Button
                          color="primary"
                          onClick={() => {
                            setShowModal(false);
                            setReferenceDataMessage(null);
                            methods.reset();
                          }}
                          className="btn-dim btn btn-secondary"
                        >
                          Cancel
                        </Button>
                      </li>
                    )}
                  </ul>
                )}
              </Col>
            </Row>
          </form>
        </FormProvider>
      </Modal>
    </>
  );
};

export default BulkUpload;